import { Icons, cn } from '@workflow/ui'

/** The job's shared instructions, available on both live work and its history. */
export function WorkDescription({ description, className }: { description: string | null; className?: string }) {
  if (!description) return null
  return (
    <details className={cn('group', className)}>
      <summary className="flex w-fit cursor-pointer list-none items-center gap-1.5 text-caption leading-none text-muted-foreground transition-colors hover:text-foreground [&::-webkit-details-marker]:hidden">
        <span className="flex size-4 items-center justify-center transition-transform duration-fast group-open:rotate-90" aria-hidden>
          <Icons.disclosure size="sm" />
        </span>
        <span>Work Description</span>
      </summary>
      <p className="mt-2 whitespace-pre-wrap break-words text-ui leading-relaxed text-foreground">{description}</p>
    </details>
  )
}
